import React from 'react';
import { Footer, Header } from '../shared';
import clsx from 'clsx';
import CookieChecker from "../shared/cookie-checker/CookieChecker";
import { WhatsappButton } from "../../components/style-guide/whatsapp-button/whatsapp-button"

import styles from './Main.module.scss';

const Main = (props) => {
    const { children, activeFooter, disabledWhatsapp = false, ...rest } = props;
    return (
        <div className="viewport-container-1200">
            <Header {...rest} />
            <div className={clsx(styles.mainLayout, "border-box h-100 p-sm-none")}>
                {children}
                {activeFooter && <Footer />}
            </div>
            {
                !activeFooter && <div className={styles.footerContainer} />
            }
            {!disabledWhatsapp && <WhatsappButton />}
            <CookieChecker />
        </div>
    );
};

export default Main;
